import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import './toggle.scss';
import classNames from "classnames";

type TToggleProps = {
    onToggle: () => void;
    heading?: string;
    explanation: string;
    className?: string;
};

// pure functional component
export const Toggle = ({heading, explanation, onToggle, className}: TToggleProps) => {
    return <div className="toggle-button-container">
            <div className="switch-container">
                <label className="switch">
                    <input type="checkbox" onClick={onToggle} className={className}/>
                    <span className={classNames("slider", "round", className)}></span>
                </label>
            </div>
            <div>
                {heading && <span className={classNames("heading", className)}>{heading} </span>}
                <span className="explanation">{explanation}</span>
            </div>
        </div>;
};